import type { RouteRecordRaw } from 'vue-router'

export const PlacementRoutes: Array<RouteRecordRaw> = [
  {
    path: '/placement',
    name: 'placement',
    meta: { requiresPlanAccess: true },
    children: [
      {
        path: '',
        name: 'placement-intro',
        component: () => import('@/views/placement/placement-intro.vue')
      },
      {
        path: 'result',
        name: 'placement-result',
        component: () => import('@/views/placement/general-placement-result.vue')
      },
      {
        path: 'exam',
        name: 'placement-exam',
        component: () => import('@/views/placement/placement-exam.vue')
      }
    ]
  }
]
